
// should go into lib/util??
const isEqual = (a,b) => (a === b)

export default (value, options) => {
  return value === options.value
}
